<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 도입/차기교정기간 -->
				<el-col :span="5">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001767') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<!-- 관리번호 -->
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001317')"
						paramKey="mesEqipNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.mesEqipNo"
					>
					</search-input>
				</el-col>
				<!-- 장비명 -->
				<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC001314')"
						paramKey="mesEqipNm"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.mesEqipNm"
					>
					</search-input>
				</el-col>

				<!-- 담당자 -->
				<el-col :span="4" >
					<search-input
						:label="getMessage_('QWCC000982')"
						paramKey="userName"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="!isMmcAdmin && isMmcUser ? searchParams.userName : ''"
						:readonly="!isMmcAdmin && isMmcUser"
						:iconReadonly="!isMmcAdmin && isMmcUser"
					>
						<template v-slot:icon > <i class="icon-sf-search search-icon" @click="onUserPopup"></i></template>
					</search-input>
				</el-col>

				<!-- 가동상태 -->
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001315')"
						paramKey="runStCd"
						:options="runStCdList"
						:propData="searchParams.runStCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>

				<!-- 교정상태 -->
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001316')"
						paramKey="calStCd"
						:options="calStCdList"
						:propData="searchParams.calStCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
		<user-popup-view ref="userPopupView" @SendData="sendData" :scrId="scrId" />
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/mmc/mmcm/MesInfo/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			searchDateRange: []
		};
	},
	components: { SearchInput, SelectCombo, PartMngPopup, UserPopupView },
	async created() {
		this.$sf_toggleLoading(true);
		this.searchDateRange = [...this.getSearchDates_];
		this.setSearchParam_({key: 'userName', value: !this.isMmcAdmin && this.isMmcUser ? this.user.userName : ''});
		await this.getCommCodesOnce_();
		await this.getMmcInstList_(); //교정업체 정보는 '부서관리'에서 관리함
		const { ubiTarget } = await this.searchList();
		this.setState_({ key: 'ubiTarget', value: ubiTarget }); //ubireport
		
		// this.setSearchParam_({key: 'userId', value: !this.isMmcAdmin && this.isMmcUser ? this.user.userId : ''});
		
		// console.log(this.searchParams);
		// const map = this.screenArray;
		
		// console.log(map);
		// console.log(Object.keys(map));
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}

			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
			if (key === 'userName') {
				this.onUserInPutKeyDown();
			}
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!(this.isMmcAdmin || this.isMmcUser)) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				return await this.getMesInfoList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		onUserPopup() {
			this.$refs.userPopupView.open(this.searchParams);
		},
		onCofPopup() {
			this.$refs.partMngPopup.open(this.searchParams.cofCd);
		},
		sendData(userData, userGbn) {
			this.setSearchParam_({ key: 'userId', value: userData.userId });
			this.setSearchParam_({ key: 'userName', value: userData.userName });
		},
		onUserInPutKeyDown() {
			this.setSearchParam_({ key: 'userId', value: '' });
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
